import { render, staticRenderFns } from "./ReasonDetailLayerPopup.vue?vue&type=template&id=63bca861&scoped=true&"
import script from "./ReasonDetailLayerPopup.vue?vue&type=script&lang=ts&"
export * from "./ReasonDetailLayerPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ReasonDetailLayerPopup.vue?vue&type=style&index=0&id=63bca861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bca861",
  null
  
)

export default component.exports